export default __webpack_public_path__ + "static/media/Cheetah.c997730f.png";